import { Component, OnInit, Input, Output, EventEmitter, AfterViewInit, OnChanges, SimpleChanges } from '@angular/core';
import { faHeartbeat, faInfoCircle, faProcedures, faChevronCircleDown, faAngleLeft } from '@fortawesome/free-solid-svg-icons';
import { DropdownFrameComponent } from '../dropdown-frame/dropdown-frame.component';
import { FlagService, AgeGroupService, DataService } from '@core/services';
import { HIPContractDto } from 'src/app/modules/_services/api/@generated/models';
// import * as $ from 'jquery';

@Component({
  selector: 'app-offer-juncture',
  templateUrl: './offer-juncture.component.html',
  styleUrls: ['./offer-juncture.component.scss'],
  standalone: false
})

export class OfferJunctureComponent implements OnInit, AfterViewInit, OnChanges {
  faHeartbeat = faHeartbeat;
  faInfoCircle = faInfoCircle;
  faProcedures = faProcedures;
  faChevronCircleDown = faChevronCircleDown;
  faAngleLeft = faAngleLeft;

  insurantData = this.DropdownFrame.returnInsurantData();

  public HIPContractDto: HIPContractDto;

  @Input() lang: string; // to trigger onChanges..
  @Output() newInsurantDataEvent = new EventEmitter<any>();
  @Output() newInsurantDataLocation = new EventEmitter<string>();

  public expanded = [];
  public expandedOrig = [];

  offerChoicesArray = new Array;
  choosenAgeGroup: boolean;
  choosenOption = new Array;

  constructor(private DropdownFrame: DropdownFrameComponent, public DataService: DataService, public FlagService: FlagService, public AgeGroupService: AgeGroupService) { }

  ngAfterViewInit(): void {
    window.scrollTo(0, this.DataService.fixInfoContainerHeight + 130);
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.HIPContractDto = JSON.parse(sessionStorage.getItem('HIPContract'));
    this.ngOnInit();
  }

  ngOnInit(): void {
    this.AgeGroupService.choosenAgeGroup[0].id === '01'? this.choosenAgeGroup = false : this.choosenAgeGroup = true;
    let HIPContract = JSON.parse(sessionStorage.getItem('HIPContract'));
    let choosenOffer = JSON.parse(sessionStorage.getItem('choosenOffer'));
    let preChoosenOffer = JSON.parse(sessionStorage.getItem('preChoosenOffer'));

    preChoosenOffer? choosenOffer = [preChoosenOffer] : null;

    if (this.HIPContractDto) {
      // filtering the choosen age group
      this.offerChoicesArray = [...this.HIPContractDto.contractGroups];
      if(!preChoosenOffer) {
        this.offerChoicesArray = this.offerChoicesArray.filter(offer => this.testAgeGroup(offer));
      }

      // set choosen offer if its pre choosen
      if(choosenOffer) {
        for(let i in this.offerChoicesArray) {
          if(this.offerChoicesArray[i].contractGroupId === choosenOffer[0].contractGroupId) {
            this.offerChoicesArray[i].active = true;
            break
          }
        }
      } else {
        // eliminaing any choosen offer
        for(let i in this.offerChoicesArray) {
          this.offerChoicesArray[i].active = false;
        }
      }
    } else {
      this.offerChoicesArray = [...HIPContract.contractGroups];
      choosenOffer = JSON.parse(sessionStorage.getItem('choosenOffer'));

      // set choosen offer if its already choosen in this session
      if(choosenOffer) {
        for(let i in this.offerChoicesArray) {
          if(this.offerChoicesArray[i].contractGroupId === choosenOffer[0].contractGroupId) {
            this.offerChoicesArray[i].active = true;
            break
          }
        }
      } else {
        // if only age group is selected but no offer selected yet
//        this.offerChoicesArray = this.DataService.HIPContractDto.contractGroups;
        this.offerChoicesArray = [...HIPContract.contractGroups];
        this.offerChoicesArray = this.offerChoicesArray.filter(offer => this.testAgeGroup(offer));
      }
    }

    if(preChoosenOffer) {
      this.sendOfferId(this.HIPContractDto.contractorName, [preChoosenOffer]);
    }

    this.expanded[0] = false;
    this.offerChoicesArray.forEach((offer, i) => {
      this.expanded[i + 1] = [];
      this.expanded[i + 1][0] = false;
      offer.first_level_risks.forEach((fRisk, j) => {
        this.expanded[i + 1][j + 1] = [];
        this.expanded[i + 1][j + 1][0] = false;
        if (fRisk.second_level_risk) {
          fRisk.second_level_risk.forEach((sRisk, k) => {
            this.expanded[i + 1][j + 1][k + 1] = false;
          });
        }
      });
    });
    this.expandedOrig = JSON.parse(JSON.stringify(this.expanded));
  }

  testAgeGroup(offer: any) {
    if (this.DataService.isKompakt()) {
      return true;
    }
    if(offer.forChildren === this.choosenAgeGroup) { return true } else { return false }
  }

  public openInfo2(i: number, j: number, k: number = -1): void {
    const expandedItem = this.expanded[i + 1][j + 1][k + 1];
    this.expanded = JSON.parse(JSON.stringify(this.expandedOrig));

    if (!expandedItem) {
      this.expanded[i + 1][j + 1][k + 1] = true;
    }
  }

  offerJunctureClick(target: any) {
    let optionId = parseInt(target.parentNode.parentNode.id.replace("collapse", ""));
    this.choosenOption = [this.offerChoicesArray.find( (elem) => elem.contractGroupId == optionId )];
    const optionIsActiveSoChooseANewOne = this.choosenOption[0].active;
    this.choosenOption[0].active = !this.choosenOption[0].active;

    // store offer options for session progress
    sessionStorage.setItem('offerChoices', JSON.stringify(this.offerChoicesArray));
    // set active state on choosen option
    this.offerChoicesArray.map(obj => this.choosenOption.find(o => o.contractGroupId === obj.contractGroupId) || obj);
    // store choosen option for session progress

    if(!this.choosenOption[0].active) {
      sessionStorage.removeItem('choosenOffer');
    } else {
      sessionStorage.setItem('choosenOffer', JSON.stringify(this.choosenOption));
    }

    this.DropdownFrame.junctureClick('familyJunctureFlag', 2);
    this.sendOfferId(this.HIPContractDto.contractorName, this.choosenOption );

    if (this.DataService.isKompakt() && this.DataService.isPartneri() && !optionIsActiveSoChooseANewOne) {
      //skip to userDataJuncture
      this.FlagService.flagServiceObject[2]['familyJunctureFlag'] = true;
      this.FlagService.flagServiceObject[3]['userdataJunctureFlag'] = true;
    }
  }

  sendOfferId(contractorName: string, choosenOption: any) {
    const ageData = JSON.parse(sessionStorage.getItem('ageGroup'));
    const isChildren = ageData[0].id === '02';
    let data = {
      couponCode: null,
      riskStartDate: this.insurantData.riskStartDate,
      contractorName: contractorName,
      koopFrameContractId: choosenOption[0].koopFrameContractId,
      contractGroupId: choosenOption[0].contractGroupId,
      contractGroupName: choosenOption[0].displayName,
      contractGroupSubName: choosenOption[0].displaySubName,
      contractGroupFirstLevelRisksName: choosenOption[0].contractGroupFirstLevelRisksName,
      isAdult: !isChildren,
      insuranceFee: choosenOption[0].insuranceFee,
      insuredPerson: null,
      interruptionId: null
    };

    const insuredPersonFromHIPDto = JSON.parse(sessionStorage.getItem('HIPInsuredPersonFromHIPDto'));
    data.couponCode = insuredPersonFromHIPDto.couponCode;
    if (insuredPersonFromHIPDto.insuredPerson) {
      data.insuredPerson = insuredPersonFromHIPDto.insuredPerson;
      data.interruptionId = insuredPersonFromHIPDto.interruptionId;
    }

    this.newInsurantDataLocation.emit('offer');
    this.newInsurantDataEvent.emit(data);
  }

  public getKompaktGroupPix(counter: number): string {
    while (counter > 14) {
      counter -= 14;
    }
    const cnt = (counter < 10 ? '0' : '') + counter.toString();
    return 'assets/contractgroup-img/kompakt/shutterstock_' + cnt + '.jpg';
  }

  getContractGroupIcon(counter: number): string {
    const imageMaxNumber = 28;
    const remainder = counter % imageMaxNumber;
    let isMod = false;

    if (counter > 0 && remainder === 0) {
      isMod = true;
    }

    let actualItemCount;

    if (counter === 0 || isMod) {
      if (remainder === 0) {
        actualItemCount = 1;
      }
      if (isMod === true) {
        actualItemCount = 28;
      }
    }
    else {
      actualItemCount = counter + 1;
    }

    return `${'assets/contractgroup-img/icon_product_'}${actualItemCount}${'.jpg'}`;
  }

  formatCurrency(price: any) {
    return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
  }

  public getIcon(iconName: string): string {
    if (!iconName) {
      iconName = 'icon-health-default.svg';
    }
    return 'assets/risk-icons/' + iconName + '#shape';
  }

  public isKompaktIcon(iconName: string): boolean {
    if (!iconName) {
      return false;
    }

    return iconName.indexOf('kompakt') > -1;
  }

}
